import React from 'react';

interface LessonIndicatorProps {
  currentLessonNumber: number;
  totalLessons: number;
}

const LessonIndicator = ({
  currentLessonNumber,
  totalLessons,
}: LessonIndicatorProps): React.JSX.Element => (
  <div className="mb-2 text-navy-500 text-sm font-semibold">
    Lesson {currentLessonNumber + 1} of {totalLessons}
  </div>
);

export default LessonIndicator;
